module.exports = __webpack_public_path__ + "static/media/standing_Human.bdac08a0.png";